import axios from 'axios';

let cachedUser = null;
let cacheTime = null;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function setCachedUser(user) {
  cachedUser = user;
  cacheTime = Date.now();
  // Persist token so it survives navigation (not localStorage — sessionStorage clears on tab close)
  if (user?.access_token) {
    sessionStorage.setItem('cc_access_token', user.access_token);
  }
}

export function clearCachedUser() {
  cachedUser = null;
  cacheTime = null;
  sessionStorage.removeItem('cc_access_token');
}

export function getStoredToken() {
  return sessionStorage.getItem('cc_access_token') || null;
}

export async function getAuthUser(API) {
  if (cachedUser && cacheTime && Date.now() - cacheTime < CACHE_TTL) {
    return cachedUser;
  }
  const delays = [0, 4000, 8000, 12000];
  let lastErr;
  for (let i = 0; i < delays.length; i++) {
    if (delays[i] > 0) await new Promise(r => setTimeout(r, delays[i]));
    try {
      // Include Bearer token for Safari iOS / browsers that block cross-site cookies (ITP)
      const token = getStoredToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await axios.get(`${API}/auth/me`, { withCredentials: true, headers, timeout: 15000 });
      setCachedUser(response.data);
      return response.data;
    } catch (err) {
      lastErr = err;
      // Los reintentos existen para el backend dormido de Render: ahi no hay respuesta,
      // o vuelve un 502/503/504 mientras despierta. Vale la pena esperar.
      //
      // Una respuesta 4xx es lo contrario: el servidor esta despierto y ya contesto. El
      // 401 de sesion vencida no va a cambiar por preguntar de nuevo, y antes se
      // reintentaba igual (solo se lanzaba en la ultima vuelta), asi que entrar con la
      // sesion vencida costaba los 24s completos de esperas antes de mostrar nada.
      if (err.response && err.response.status < 500) throw err;
    }
  }
  throw lastErr;
}
